import LabServiceModel from "@/models/LabServiceModel";
import SampleModel from "./SampleModel";
import ScheduleModel from "./ScheduleModel";

export default class ScheduleSampleModel extends LabServiceModel {
  modelName() {
    return "schedule-sample";
  }
  defaults() {
    return {
      id: null,
      schedule_id: null,
      sample_id: null,
      order: null,
      auto_scheduled: null,
      manually_scheduled: null,
      updated_at: null,
      created_at: null,
    };
  }
  mutations() {
    return {
        id: val => this.nullStringMutator(val),
        schedule_id: val => this.nullStringMutator(val),
        sample_id: val => this.nullStringMutator(val),
        order: val => this.nullStringMutator(val),
        auto_scheduled: val => this.nullStringMutator(val),
        manually_scheduled: val => this.nullStringMutator(val),
        updated_at: val => this.nullStringMutator(val),
        created_at: val => this.nullStringMutator(val),
    };
  }
  validation() {
    return {};
  }

  getSchedule() {
    return this.getRelatedModel(ScheduleModel, 'schedule');
  }

  getSample() {
    return this.getRelatedModel(SampleModel, 'sample');
  }

}
